<template>
  <div class="card">
    <img :src="resolvedPhotoUrl" alt="translator photo" class="photo" />
    <h3 class="name">{{ name }}</h3>
    
    <p class="university" v-if="universityName || universityDepartment">
      {{ universityName }}<span v-if="universityDepartment"> / {{ universityDepartment }}</span>
    </p>
    
    <p class="experience" v-if="experience">{{ experience }}</p>
    <p class="languages">{{ languages }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: String,
  photo: String,
  universityName: String,
  universityDepartment: String,
  experience: String,
  languages: String
})

const baseURL = process.env.VUE_APP_API_URL

const resolvedPhotoUrl = computed(() => {
  if (!props.photo) {
    return `${baseURL}/uploads/avatar/default-avatar.png`
  }

  return props.photo.startsWith('http')
    ? props.photo
    : `${baseURL}/uploads/avatar/${props.photo}`
})
</script>

<style scoped>
.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 18px;
  width: 100%;
  max-width: 260px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}

.photo {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 14px;
  border: 3px solid #0c2d57;
}

.name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0c2d57;
  margin-bottom: 6px;
}

.university {
  font-size: 0.9rem;
  color: #666;
  font-style: italic;
  margin-bottom: 4px;
}

.experience {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 6px;
}

.languages {
  font-size: 0.9rem;
  color: #333;
}
@media (max-width: 480px) {
  .card {
    max-width: 100%;
    padding: 20px 14px;
    border-radius: 12px;
  }

  .photo {
    width: 80px;
    height: 80px;
    margin-bottom: 12px;
  }

  .name {
    font-size: 1rem;
  }

  .university,
  .experience,
  .languages {
    font-size: 0.85rem;
    word-wrap: break-word;
  }
}

</style>
